export class AppConstants {
  static readonly numberRegex: RegExp = /\d/;
  static readonly specCharRegex: RegExp = /[^A-Za-z0-9]/;
  static readonly lowerLetterRegex: RegExp = /[a-z]/;
  static readonly capsLetterRegex: RegExp = /[A-Z]/;
  static readonly adminBasePath = '/adminpanel/';
  static readonly imageSizeLimit = 2000000;
}
